/* eslint-disable */
import { produce } from "immer";
import {
  PENSION_LAB_CONSENT_FETCH_FAILURE,
  PENSION_LAB_CONSENT_FETCH_START,
  PENSION_LAB_CONSENT_FETCH_SUCCESS,
} from "../actions/types";

const getPensionLabConsentReducer = (
  state = {
    pensionConsentFetching: false,
    pensionConsentData: [],
    pensionConsentError: null,
  },
  action,
) => {
  switch (action.type) {
    case PENSION_LAB_CONSENT_FETCH_START:
      return produce(state, (draft) => {
        draft.pensionConsentFetching = true;
      });
    case PENSION_LAB_CONSENT_FETCH_SUCCESS:
      return produce(state, (draft) => {
        draft.pensionConsentFetching = true;
        draft.pensionConsentData = action.data;
        draft.pensionConsentFetching = false;
      });
    case PENSION_LAB_CONSENT_FETCH_FAILURE:
      return produce(state, (draft) => {
        draft.pensionConsentFetching = false;
        draft.pensionConsentError = action.error;
      });
    default:
      return state;
  }
};

export default getPensionLabConsentReducer;
